module.exports = __webpack_public_path__ + "static/media/feature-mini-card2.c1f0c476.webp";